import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'crm-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  currentYear: any;

  ngOnInit() {
    this.currentYear = new Date().getFullYear();

  }

}
